import { Component, Host, h, Element, Prop } from '@stencil/core';

export interface AhaPromoCard extends HTMLAhaPromoCardElement {}

/**
 * aha-promo-card is a component that displays a promo card.
 * @slot image - Contents of the image slot.
 * @slot title - Contents of the title slot.
 * @slot description - Contents of the description slot.
 * @slot actions - Contents of the actions slot.
 */
@Component({
  tag: 'aha-promo-card',
  styleUrl: 'aha-promo-card.css',
  shadow: true,
})
export class AhaPromoCard {
  @Element() host!: HTMLAhaPromoCardElement;

  /**
   * Adds an overlay behind the card, relative to it's container.
   */
  @Prop({ reflect: true, attribute: 'with-overlay' }) withOverlay: boolean = false;

  render() {
    return (
      <Host>
        <div id="aha-promo-card__promo-container">
          <slot name="image"></slot>
          <slot name="title"></slot>
          <slot name="description"></slot>
          <div id="aha-promo-card__actions-container">
            <slot name="actions"></slot>
          </div>
        </div>
      </Host>
    );
  }
}
